import { Component, OnInit, Input } from '@angular/core'
import { Observable, of } from 'rxjs'
import { User, AuthService } from '@spartacus/core'
import { QuoteCheckoutService } from '../../../quote-checkout/services/quote-checkout.service'
import { switchMap } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'

@Component({
  standalone: false,
  selector: 'vs-review-compliance-question',
  templateUrl: './review-compliance-question.component.html',
  styleUrls: ['./review-compliance-question.component.scss'],
})
export class ReviewComplianceQuestionComponent implements OnInit {
  isLoggedIn = false
  reviewData: any
  @Input() complianceQuestionData: any
  @Input() warningFlagText: any
  isLoggedinUser = false
  public cartId
  public cartStatus
  public userType
  user$: Observable<User>
  loggedIn: boolean
  cartLoaded = false
  allQuestions: any
  allQuestions$: Observable<any>
  productData: any

  constructor(
    private quoteCheckoutService: QuoteCheckoutService,
    private auth: AuthService,

    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
        this.cartId = sessionStorage.getItem('cartId-' + this.userType)
        this.getQuestions()
      } else {
        this.userType = 'anonymous'
        this.cartId = sessionStorage.getItem('cartId-' + this.userType)
        this.getQuestions()
      }
    })
  }
  getQuestions() {
    this.allQuestions$ = this.quoteCheckoutService.getQuestions(this.cartId)
    this.allQuestions$.subscribe((data) => {
      this.allQuestions = data
    })
  }
}
